import { autoWebViewJs, isRealInAndroid } from '@droid/android';

import { androidController, autoJsStoreUtils } from '@droid/android';
import { Dispatcher, Log, browserHistoryUtils, listenDocumentActive, storeUtils, tabActivity } from '@fanfanlo';
import { user } from '../../user/User';
import { initAndroid } from './initAndroid';
import { appPackagesStoreV2 } from '@app/static';
import { projectStore as projectStoreV2, projectEventUtils as projectEventUtilsV2 } from "@droid/project-v2-interface";
import { initProjectSystem as initProjectSystemV2 } from "@droid/project-v2-ext";
// 使用动态导入避免循环依赖
// import { projectListSyncManager } from "@droid/project-v2-ui";
// @autobind
const fileLog = new Log(false, 'AppController_f')
fileLog.pause = true;
fileLog.childrenPaused = true;
class AppController extends Dispatcher {
  constructor() {
    super();
  }
  async init() {
    fileLog.log('[AppController.init] 开始初始化AppController')
    await appPackagesStoreV2.init();
    fileLog.log('[AppController.init] appPackagesStoreV2.init() 调用完成')
    const storeUtilsConf = {
      read: autoJsStoreUtils.read,
      write: autoJsStoreUtils.write,
      ns: {},
    };
    listenDocumentActive();
    // projectInterfaceController.init();
    browserHistoryUtils.initBrowserHistoryListener();
    fileLog.log('[AppController.init] 准备调用projectController.init()')
    // await projectController.init()
    fileLog.log('[AppController.init] projectController.init() 调用完成')
    fileLog.log('[AppController.init] 准备初始化 project-v2 系统')
    projectEventUtilsV2.init();
    fileLog.log('[AppController.init] projectEventUtilsV2.init() 调用完成')
    projectStoreV2.init();
    fileLog.log('[AppController.init] projectStoreV2.init() 调用完成')
    initProjectSystemV2();
    fileLog.log('[AppController.init] initProjectSystemV2() 调用完成 (包含 initTriggers 和 initActions)')
    fileLog.log('[AppController.init] project-v2 系统初始化完成')
    await initAndroid();
    // initJsBridge()
    await androidController.init();
    // autoWebViewJs?.onDocumentReady()
    setTimeout(() => {
        fileLog.log('has autowebviewjs', autoWebViewJs)
      autoWebViewJs?.onDocumentReady();
      fileLog.log('autowebviewjs on document ready')
    }, 1000 * 5);
    if (autoWebViewJs) {
      Object.defineProperty(window, 'autoWebViewJs', {
        value: autoWebViewJs,
        writable: false,
        configurable: false,
        enumerable: false, // 可选：不让它出现在 for...in 中
      });
      //   (global as any).autoWebViewJs = autoWebViewJs;
      // lockMethods(autoWebViewJs)
    }
    (window as any).storeUtilsConf = storeUtilsConf;
    tabActivity.init();
    if (isRealInAndroid) {
      storeUtils.setStoresProxy({
        read: autoJsStoreUtils.read,
        write: autoJsStoreUtils.write,
        ns: {},
      });
    }
    // await user.init()
    // 不阻塞
    // 不需要阻塞，现在不需要初始化时必须先登录
    initDependOnRemote();
  }
}

async function initDependOnRemote() {
  await user.init();
  // 使用动态导入避免循环依赖
  try {
    const { projectManager } = await import("@droid/project-v2-ui");
    fileLog.log('[initDependOnRemote] 动态导入 projectListSyncManager 成功');
    await projectManager.init();
    fileLog.log('[initDependOnRemote] projectListSyncManager.init() 调用完成');
  } catch (error) {
    fileLog.log('[initDependOnRemote] 动态导入 projectListSyncManager 失败:', error);
  }
}
export const appController = new AppController();
